import { useEffect, useState } from "react";
import "./styles.css";

export default function Clue1 () {
  const [refreshes, setRefreshes] = useState([]);
  const [questions, setQuestions] = useState([]);

  // Existing refresh animation
  useEffect(() => {
    const interval = setInterval(() => {
      const id = Date.now();

      const newRefresh = {
        id,
        top: Math.random() * 80 + 5,
        left: Math.random() * 80 + 5,
        rotate: Math.random() * 60 - 30,
        scale: 1 + Math.random(),
        duration: 3000 + Math.random() * 1000
      };

      setRefreshes(prev => [...prev, newRefresh]);

      setTimeout(() => {
        setRefreshes(prev => prev.filter(r => r.id !== id));
      }, newRefresh.duration);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Generate spinning question marks once
  useEffect(() => {
    const count = 6 + Math.floor(Math.random() * 5); // 6–10 marks

    const qs = Array.from({ length: count }).map((_, i) => ({
      id: i,
      top: Math.random() * 80 + 5,
      left: Math.random() * 80 + 5,
      size: 24 + Math.random() * 36, // 24–60px
      speed: 4 + Math.random() * 6   // rotation speed
    }));

    setQuestions(qs);
  }, []);

  return (
    <div className="start-container">
      <div className="congrats">
        <p>
          <span className="upside-down">
            Congratulations. You have solved your first clue.
          </span>
        </p>
        <p>
          There are many of you.
          You will need each individual set of skills to get to the end.
          Introduce yourselves, then wait a day and <span className="highlight-refresh">refresh</span> the page.
          It may take a few days. Good luck.
        </p>
      </div>

      <div className="contacts">
        713 876 8462 <br />
        210 867 7030 <br />
        214 437 2932 <br />
        713 447 3014 <br />
        210 602 6800 <br />
        361 563 5247 <br />
        713 825 2713 <br />
      </div>

      {/* Red popping refresh words */}
      {refreshes.map(r => (
        <div
          key={r.id}
          className="floating-refresh"
          style={{
            top: `${r.top}vh`,
            left: `${r.left}vw`,
            "--rotation": `${r.rotate}deg`,
            "--scale": r.scale,
            "--duration": `${r.duration}ms`
          }}
        >
          refresh
        </div>
      ))}

      {/* Spinning green question marks */}
      {questions.map(q => (
        <div
          key={q.id}
          className="floating-question"
          style={{
            top: `${q.top}vh`,
            left: `${q.left}vw`,
            fontSize: `${q.size}px`,
            animationDuration: `${q.speed}s`
          }}
        >
          ?
        </div>
      ))}
    </div>
  );
}
